import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import AdminLayout from 'src/layouts/admin';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const AgenciesListPage = lazy(() => import('src/pages/admin/agencies/list'));
const AgencyOverviewPage = lazy(() => import('src/pages/admin/agencies/overview'));
const AuditLogPage = lazy(() => import('src/pages/admin/audit/list'));
const PlatformAdminsPage = lazy(() => import('src/pages/admin/admins/list'));
const BillingPage = lazy(() => import('src/pages/admin/billing/list'));

// Platform administration portal (epic #45). Gated by AuthGuard, which funnels platform-admins here
// and bounces everyone else out (ADR-0002); the backend PlatformAdmin policy is the real authority.
export const adminRoutes = [
  {
    path: 'admin',
    element: (
      <AuthGuard>
        <AdminLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AdminLayout>
      </AuthGuard>
    ),
    children: [
      { element: <Navigate to="agencies" replace />, index: true },
      { path: 'agencies', element: <AgenciesListPage /> },
      // Slice 5 (#50): read-only view-as support, audit trail, platform-admin management.
      { path: 'agencies/:number/overview', element: <AgencyOverviewPage /> },
      { path: 'audit', element: <AuditLogPage /> },
      { path: 'admins', element: <PlatformAdminsPage /> },
      // Slice 1 (#57): platform billing config — global rate card + per-agency profiles.
      { path: 'billing', element: <BillingPage /> },
    ],
  },
];
